import React from "react";
import HIGTextArea from "@hig/text-area";
import styled from "styled-components";
import PropTypes from "prop-types";

const TextArea = ({
  handleChange,
  className,
  placeholder,
  id,
  showWordCount
}) => {
  const handleTextChange = e => {
    if (showWordCount) {
      // added logic to count words.
      const strLength = e.target.value.length;
      document.getElementById("wordCountValue").innerText = strLength;
    } // else this call.


    handleChange(e);
  };

  return /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
    }
  }, /*#__PURE__*/React.createElement(HIGTextArea, {
    className: className,
    variant: "box",
    placeholder: placeholder,
    onChange: e => handleTextChange(e),
    id: id
  }), showWordCount && /*#__PURE__*/React.createElement(WordCount, null, /*#__PURE__*/React.createElement("span", {
    id: "wordCountValue"
  }, "0"), " /1000"));
};

TextArea.propTypes = {
  handleChange: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string
};
const WordCount = styled.p`
  margin-top: -5px;
  float: right;
  font-size: 12px;
  margin-right: 5px;
  color: #999;
  font-family: AdsktmArtifaktElement;
`;
export default styled(TextArea)`
  margin-bottom: 10px;
  > div > textarea {
    height: 100px;
    :focus {
      border: 1px solid #0696d7;
      box-shadow: 0 0 5px #0696d7;
    }
    ::placeholder {
      font-style: italic;
    }
  }
  > div > div {
    height: 0px;
  }
`;